module.exports = __webpack_public_path__ + "img/20_dice[3].33c63e78.png";